import { useState } from 'react';
import { TRAVEL_TYPE_HOLIDAY_HOMES, TRAVEL_TYPE_OWN_ARRIVAL, TRAVEL_TYPE_PACKAGE_TOUR } from '../../../../../components/models.js';
import { TravelTypeChanged } from '../../../../../components/SearchForm/actionTypes.js';
export const useTravelTypeField = ({
  value: controlledValue,
  config,
  dispatch
}) => {
  const [value, setValue] = useState(controlledValue);
  // "Fake" widget state management due to `isActive` logic needed on top level in SearchForm.tsx
  // in order to correctly display or hide field dividers on hover
  const [widgetOpen, setWidgetOpen] = useState(false);
  if (!config) {
    return null;
  }
  const {
    options,
    mode,
    onChange
  } = config;
  const handleChange = nextValue => {
    if ([TRAVEL_TYPE_OWN_ARRIVAL, TRAVEL_TYPE_PACKAGE_TOUR, TRAVEL_TYPE_HOLIDAY_HOMES].includes(nextValue)) {
      dispatch({
        type: TravelTypeChanged,
        payload: {
          travelType: nextValue
        }
      });
    }
    setValue(nextValue);
    // Some options have externally defined change handlers, e.g. link-outs
    onChange(nextValue);
  };
  const setValueHandler = nextValue => {
    if (nextValue !== value) {
      dispatch({
        type: TravelTypeChanged,
        payload: {
          travelType: nextValue
        }
      });
      setValue(nextValue);
    }
  };
  const handleBlur = () => setWidgetOpen(false);
  const handleFocus = () => setWidgetOpen(true);
  const getFieldProps = () => ({
    value,
    options,
    mode,
    // State is managed in the field component as there is no widget
    onChange: handleChange,
    // These are passed on directly to react-select and used as callbacks to manage active state here
    onFocus: handleFocus,
    onBlur: handleBlur,
    widgetOpen
  });
  return {
    isActive: widgetOpen,
    getFieldProps,
    setValue: setValueHandler
  };
};